import { forwardRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './CurriculumRow.module.scss'

const ICON_CLASSES = {
  video: classes.iconVideo,
  reading: classes.iconReading,
  quiz: classes.iconQuiz,
  missing: classes.iconMissing,
}

const CurriculumRow = forwardRef(({ icon, iconVariant, title, muted = false, meta, badge, handle, selected, onSelect, style }, ref) => (
  <div ref={ref} style={style} className={classNames('d-flex align-items-center', classes.row, { [classes.rowSelected]: selected })}>
    {handle}
    <button className={classNames('d-flex align-items-center flex-grow-1 text-left', classes.button)} onClick={onSelect}>
      <span className={classNames('d-inline-flex align-items-center justify-content-center', classes.icon, ICON_CLASSES[iconVariant])}>
        {icon}
      </span>
      <span className={classes.text}>
        <span className={classNames(classes.title, { [classes.titleMuted]: muted })}>{title}</span>
        <span className={classes.meta}>{meta}</span>
      </span>
      {badge && <span className={classes.badge}>{badge}</span>}
    </button>
  </div>
))

CurriculumRow.displayName = 'CurriculumRow'

CurriculumRow.propTypes = {
  icon: PropTypes.node.isRequired,
  iconVariant: PropTypes.oneOf(['video', 'reading', 'quiz', 'missing']).isRequired,
  title: PropTypes.string.isRequired,
  muted: PropTypes.bool,
  meta: PropTypes.string.isRequired,
  badge: PropTypes.string,
  handle: PropTypes.node,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  style: PropTypes.object,
}

export default CurriculumRow
